const FromArr = [{
		modelvalue: "",
		title: "经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: "",
		title: "申请单号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 65,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: "",
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		multiple: true,
		collapseTags: true,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 42,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		modelvalue: "",
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 58,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		title: "创建时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		heightLeft: 32,
		heightRight: 32,
		widthLeft: 190,
		widthRight: 265,
		disabled: false,
		marginLeft: 65,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: "",
		title: "证照状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
				key: '1',
				value: '有效证照'
			},
			{
				key: '0',
				value: '待审证照'
			},
			{
				key: '-1',
				value: '驳回证照'
			},
			{
				key: '-2',
				value: '未上传证照'
			}
		]
	},
];
export default FromArr;